export const additionalPlanLinksContentKey: string = "additionalPlanLinksContentKey"